import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { PermissionService } from '../../services/permission.service';
import { MdlChangestatuscomponent } from '../../components/mdl-change-taskStatus/mdl-change-taskStatus';
import { MDLModifyTask } from '../../components/mdl-modify-task/mdl-modify-task';
import { MdlDeleteTask } from '../../components/mdl-delete-task/mdl-delete-task';
import { MdlmanageContract } from '../../components/mdl-manage-contract/mdl-manage-contract';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { MdlManageContact } from '../../components/mdl-manage-contact/mdl-manage-contact';
import { MdlManageProspect } from '../../components/mdl-manage-prospect/mdl-manage-prospect';
import { MdlSendMail } from '../../components/mdl-send-mail/mdl-send-mail';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { MdlNewEventComponent } from '../../components/mdl-new-event/mdl-new-event';
import { AlertService } from '../../services/alert.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contract-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    FormsModule,
  ],
  templateUrl: './contract-detail.html',
  styleUrl: './contract-detail.css',
})
export class ContractDetail implements OnInit {
  public contrato: any = {};
  public oportunidad: any = {};
  public api = inject(Api);
  public isLoading: boolean = true;
  public errorMessage: string = '';
  showRecentDropdown: boolean = false;
  openedMenuId: string | null = null;

  public editInfo: boolean = false;
  public editableContrato: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public permissionService: PermissionService,
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef,
    private dialog: MatDialog,
    private alertService: AlertService
  ) {
    this.route.params.subscribe((params) => {
      const contractId = params['id'];
      if (contractId) {
        this.cargarContrato(contractId);
      } else {
        this.errorMessage = 'No se proporcionó un ID de contrato';
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {}

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  cargarContrato(id: string): void {
    this.api.showLoading();
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getContractbyId(id).subscribe({
      next: (data: any) => {
        this.contrato = data.contrato;
        this.oportunidad = data.contrato?.oportunidades || null;
        this.isLoading = false;
        console.log('Contrato:', this.contrato);

        setTimeout(() => {
          this.api.hideLoading();
        }, 500);
      },
      error: (err: any) => {
        console.error('Error en API:', err);

        if (err.status === 403) {
          this.errorMessage = 'No tienes permiso para ver este contrato.';
          this.router.navigateByUrl('/contracts');
        } else {
          this.errorMessage = 'Error al cargar el contrato.';
        }

        this.isLoading = false;
        this.api.hideLoading();
      },
    });
  }

  openmdlupdateContract(data: any) {
    console.log('Click');
    this.dialog.open(MdlmanageContract, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'edit',
        contrato: data,
      },
    });
  }

  openmdldeleteContract(id: string): void {
    this.dialog.open(MdlDelete, {
      minWidth: '400px',
      maxHeight: '600px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'contracts',
        ids: [id],
      },
    });
  }

  openMdlCreateContact() {
    this.dialog.open(MdlManageContact, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create',
      },
    });
  }

  openMdlCreateProspect() {
    this.dialog.open(MdlManageProspect, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create',
      },
    });
  }

  openSendMail() {
    this.dialog.open(MdlSendMail, {
      minWidth: '750px',
      maxHeight: '700px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'add', // o 'edit'
        mailData: { // Datos iniciales opcionales
          from: 'usuario@empresa.com',
          asunto: 'Asunto predefinido'
        },
        destinatarios: ['cliente@empresa.com'],
        tipo: 'individual'
      }
    });
  }

  openNewCall(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.contrato,
        mode: 'call',
        tipo: 'PRO',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewTask(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.contrato,
        mode: 'task',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewEvent(): void {
    this.dialog.open(MdlNewEventComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.contrato,
        mode: 'event',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  toggleEdit(section: 'info'){
    this.editInfo = !this.editInfo;
    if (this.editInfo) {
      this.editableContrato = { ...this.contrato };
    }
  }

  cancelEdit(section: 'info'){
    this.editInfo = false;
    this.editableContrato = { ...this.contrato };
  }

  saveSection(section: 'info'){
    this.api.updateContract(this.editableContrato).subscribe({
      next: (resp: any) => {
        this.alertService.success('Éxito', 'Contrato actualizado correctamente');
        this.contrato = { ...this.editableContrato };
        this.editInfo = false;
      },
      error: (err) => {
        this.alertService.error('Error', 'Error al actualizar contrato');
        console.error(err);
      }
    })
  }

  selectedRecordatorio: { valor: number; unidad: string } | null = null;

  onRecordatorioChange() {
    if (this.selectedRecordatorio) {
      this.editableContrato.recordatorio_valor = this.selectedRecordatorio.valor;
      this.editableContrato.recordatorio_unidad = this.selectedRecordatorio.unidad;
    }
  }

}

